import { createSlice } from "@reduxjs/toolkit";
import { fetchFiles, uploadNewFile, deleteUploadedFile } from "../../actions/files/filesData";

const initialState = {
  filesCount: 0,
  filesData: [],
  isFilesLoading: true,
  isFilesUploading: false,
  isFilesDeleting: false,
};

export const fileSlice = createSlice({
  name: "files",
  initialState,
  reducers: {
    files: (state, { payload }) => {},
  },
  extraReducers: {
    [fetchFiles.pending]: (state) => {
      state.isFilesLoading = true;
    },
    [fetchFiles.fulfilled]: (state, { payload }) => {
      state.filesData = payload?.results;
      state.filesCount = payload?.count;
      state.isFilesLoading = false;
    },
    [fetchFiles.rejected]: (state, { payload }) => {
      state.isFilesLoading = false;
    },
    [uploadNewFile.pending]: (state) => {
      state.isFilesUploading = true;
    },
    [uploadNewFile.fulfilled]: (state, { payload }) => {
      state.isFilesUploading = false;
    },
    [uploadNewFile.rejected]: (state, { payload }) => {
      state.isFilesUploading = false;
    },
    [deleteUploadedFile.pending]: (state) => {
      state.isFilesDeleting = true;
    },
    [deleteUploadedFile.fulfilled]: (state, { payload }) => {
      state.isFilesDeleting = false;
    },
    [deleteUploadedFile.rejected]: (state, { payload }) => {
      state.isFilesDeleting = false;
    },
  },
});

export const { files } = fileSlice.actions;

export default fileSlice.reducer;
